import { t } from "@redotech/redo-i18n";
import { Condition as ModelCondition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  customerEmailFromModel,
  validateCustomerEmailCondition,
  type CustomerEmailState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const CUSTOMER_EMAIL = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CustomerEmailState>>,
): ConditionType<CustomerEmailState, ModelCondition.CustomerEmail> => ({
  name: CONDITION_NAMES[ModelCondition.CUSTOMER_EMAIL],
  description(state) {
    return t("Customer emails: {{emails}}", { emails: state.join(", ") });
  },
  Details(props: ConditionTypeDetailsProps<CustomerEmailState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return customerEmailFromModel(model);
  },
  toModel(state) {
    return { type: ModelCondition.CUSTOMER_EMAIL, emails: state };
  },
  valid(state) {
    return validateCustomerEmailCondition(state).valid;
  },
});
